<template>
  <b-form>
    <b-form-group :label="`${$t('contact.name')} *`" label-for="contact-name" class="mb-2">
      <b-form-input
        id="contact-name"
        v-model="$v.value.name.$model"
        :state="isValidField('name')"
        required
        size="sm"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="mb-2"
      :label="$t('contact.fiscalEntity')"
      label-for="contact-fiscalEntity"
    >
      <b-form-input
        id="fiscalEntity"
        v-model="value.fiscalEntity"
        type="text"
        size="sm"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      required
      :label="`${$t('contact.email')} *`"
      label-for="contact-email"
      class="mb-2"
    >
      <b-form-input
        id="contact-email"
        v-model="$v.value.email.$model"
        type="email"
        required
        size="sm"
        :state="isValidField('email')"
      ></b-form-input>
      <b-form-invalid-feedback>
        {{ $t('contact.emailError') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      class="mb-2"
      :label="`${$t('contact.phone')} *`"
      label-for="contact-phoneNumber"
    >
      <b-form-input
        id="contact-phoneNumber"
        v-model="$v.value.phoneNumber.$model"
        :state="isValidField('phoneNumber')"
        required
        type="tel"
        size="sm"
      ></b-form-input>
    </b-form-group>

    <div class="row">
      <div class="col col-8">
        <b-form-group
          :label="$t('contact.street')"
          label-for="contact-street"
          class="mb-2"
        >
          <b-form-input
            id="contact-street"
            v-model="value.street"
            type="text"
            size="sm"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col col-4">
        <b-form-group
          :label="$t('contact.postalCode')"
          label-for="contact-postalCode"
          class="mb-2"
        >
          <b-form-input
            id="contact-postalCode"
            v-model="value.postalCode"
            type="number"
            size="sm"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <b-form-group
      :label="`${$t('contact.city')} *`"
      label-for="contact-city"
      class="mb-2"
    >
      <b-form-input
        id="contact-city"
        v-model="$v.value.city.$model"
        :state="isValidField('city')"
        type="text"
        size="sm"
      ></b-form-input>
    </b-form-group>
  </b-form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'ContactForm',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      phoneNumber: {
        required
      },
      city: {
        required
      },
      email: {
        email,
        required
      }
    }
  },
  methods: {
    isValidField (field) {
      return this.$v.value[field].$dirty ? !this.$v.value[field].$invalid : null
    }
  }
}
</script>
